<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ImvGRC/tc-custom/9781439677537.jpg?1704886029789" alt="This image is the cover for the book Colorado in the Civil War, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Colorado in the Civil War, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>Colorado troops were vitally important for the Union in the quest to win the Civil War. They served throughout the American West from Missouri to Utah, and their enemies were not only ordinary Confederate troops but also fearsome guerrillas under William Quantrill and "Blood Bill" Anderson. Vital Western transportation routes--like the Santa Fe, Oregon, Smoky Hill, and Cherokee Trails--were guarded by the Coloradans. Tragically, actions by Colorado soldiers, including the horrific Sand Creek Massacre, ignited decades of warfare with Native American tribes. This book features vintage images that chronicle Colorado's Civil War soldiers, where they served, and who they fought.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John F. Steinle
      </h2>
      
      <p class="authorDescription body article">John Steinle, a native of Hamilton, Ohio, received a master's degree in museum and archival management from Wright State University. Steinle worked as a curator and archivist at the Cincinnati Art Museum and Cincinnati Historical Society and served as a director at several Ohio museums before moving to Colorado in 1992. In 1994, he became the administrator of the Hiwan Homestead Museum in Evergreen, Colorado, working for Jefferson County Open Space. He was later promoted to history education supervisor and region supervisor for the Bear Creek Region. He retired in 2016.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18ed465e